import {gql} from "@apollo/client";
import {createEstablishmentMutation, getAllEstablishmentsQuery} from "./establishmentGql";
import filterDataGql, {executeQueryUtil} from "../utils/gqlUtil";
import apolloClient from "../apolloClient/ApolloClient";


const common = `
  id
  name
  code
  title
  height
  mdDescription
  chartMediaUrl
  allowedCategoryFilter
  allowedProductFilter
  allowedStaffFilter
  allowedLocationFilter
  allowedEstablishmentFilter
  
  allowedGroupByLocation
  allowedGroupByStaff
  allowedGroupByCategory
  allowedGroupByEstablishment
  chartCategoryId
`

export const getChartImplementationsQuery = () => {

  return gql`
    query {
      getChartImplementations {
        ${common}
      }
    }
  `;
}

export const getChartImplementationQuery = (chartImplementationId) => {

    return gql`
    query {
      getChartImplementation(chartImplementationId: "${chartImplementationId}") {
        ${common}
      }
    }
  `;
}

export const createChartImplementationMutation = (data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        [] );
    return gql`mutation {
      addChartImplementation(data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const updateChartImplementationMutation = (data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        ["groupBy"] );
    return gql`mutation {
      updateChartImplementation(data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const bulkDeleteChartImplementationMutation = (ids) => {
    var idsString =  JSON.stringify(ids);

    return gql`
    mutation {
      bulkDeleteChartImplementation(chartImplementationIds: ${idsString}) {
        ids
      }
    }
  `;
}

export const addDataChartImplementationToCache = async (datas) => {
    if (!datas) {
        return
    }
    const query = getChartImplementationsQuery();
    const data = await executeQueryUtil(query);

    if (data) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getChartImplementations: [...data.data.getChartImplementations, ...datas]
            },
        });
    }
}

export const deleteChartImplementationFromCache = async (ids) => {
    const query = getChartImplementationsQuery();
    const res = await executeQueryUtil(query);
    const newData = res.data.getChartImplementations.filter(item =>
        !ids.includes(item.id)
    )

    if (res) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getChartImplementations: [...newData]
            },
        });
    }
}






